import Alpine from 'alpinejs'
import { createGlobalConsentManager } from './modules/consent-manager'
import ConsentManagerUI from './modules/alpine/consent-manager-ui'
import ToggleSwitch from './modules/alpine/toggle-switch'
import { domReady } from './util/helpers'

const alpineConfig = window.obConsentManagerConfig.ui.alpine

const collapsePluginPromise = alpineConfig.include.collapsePlugin
  ? import('@alpinejs/collapse')
  : Promise.resolve({ default() {} })
const focusPluginPromise = alpineConfig.include.focusPlugin
  ? import('@alpinejs/focus')
  : Promise.resolve({ default() {} })

async function init() {
  // Install public Alpine plugins
  let alpinePlugins = await Promise.all([collapsePluginPromise, focusPluginPromise])

  for (let { default: plugin } of alpinePlugins) {
    Alpine.plugin(plugin)
  }

  // Install custom Alpine components
  Alpine.data('obToggleSwitch', ToggleSwitch)
  Alpine.data('obConsentManagerUI', ConsentManagerUI)

  let manager = createGlobalConsentManager()

  // Find elements that were blocked on the server side
  manager.findServerSideBlockedElements()

  // Display placeholders for blocked elements
  manager.addPlaceholders()

  // Unblock all elements for which the user has given consent
  manager.autoUnblock()

  let template = document.querySelector<HTMLTemplateElement>('#ob-consent-manager-template')
  if (!template) {
    if (DEV_MODE) console.warn('Could not find Consent Manager template')
  } else {
    // Render template
    template.parentNode!.insertBefore(template.content, template)
    template.remove()
  }
}

if (alpineConfig.include.core) {
  domReady.then(() => {
    Alpine.prefix(`${alpineConfig.prefix}-`)
    Alpine.start()
    init()
  })
} else {
  window.addEventListener('alpine:init', init)
}
